import { Page } from './page';

new Page(document);